import axios from '../axios'

// 指定生徒の成績・進捗（teacher=担当のみ / admin=全）
const getStudentGradesApi = async (studentId) => {
  return await axios.get(`api/lms/students/${studentId}/grades`)
}

export default getStudentGradesApi
